module.exports = __webpack_public_path__ + "static/media/Course.768c6cb0.jpg";